module.exports = __webpack_public_path__ + "files/05d83981eb6c059bcbd91429fd27fde0.png";